<template>
  <div class="dashboard">
    <div class="flex xs12 sm2">
      <va-date-picker
        :label="$t('tables.date')"
        v-model="date"
      />
    </div>
    <dashboard-operation-info-block />
    <dashboard-load-charts />
  </div>
</template>

<script>
import DashboardLoadCharts from './DashboardLoadCharts'
import DashboardOperationInfoBlock from './DashboardOperationInfoBlock'
import DashboardTable from './DashboardTable'
import DashboardTabs from './DashboardTabs'
import DashboardMap from './DashboardMap'
import { EventBus } from '@/event-bus'
import moment from 'moment'
import { mapState } from "vuex";
import LoadAPI from '@/services/LoadAPI'

export default {
  name: 'dashboard',
  components: {
    DashboardLoadCharts,
    DashboardOperationInfoBlock,
    DashboardTable,
    DashboardTabs,
    DashboardMap,
  },
  data () {
    return {
      date:  '', //moment(new(Date)).format('YYYY-MM-DD')
      interval: '',
    }
  },

  mounted() {

    const params = {
      locality: this.currentLocality.id,
      date: this.date
    }

    if (this.$route.params.date !== undefined) {
      this.date = `${this.$route.params.date}`
    } else {
      this.readDeliveryDate(this.currentLocality.id)
    }

    this.interval = setInterval(() => {
      document.location.reload(true);
    }, 60000)

  },

  beforeDestroy(){
    window.clearInterval(this.interval); 
  },

  computed: {
    ...mapState(['currentLocality']),
  },

  watch: {
    date: function(newDate) {
      let dateFormated = moment(newDate).format('DD/MM/YYYY');

      EventBus.$emit('dashborad_delivery_date_changed', dateFormated);
    },

    '$store.state.currentLocality': function() {
      EventBus.$emit('dashborad_delivery_date_changed', this.date);
    },

  },

  methods:{
    async readDeliveryDate (localityId) {
      await LoadAPI.getLastDeliveryDate(localityId).then(response => {
        this.date = response.data.last_delivery_date
      }).catch(e => {
        showError(e)
      });
    },
  },
}

</script>

<style lang="scss">
  .row-equal .flex {
    .va-card {
      height: 100%;
    }
  }
  .dashboard {
    .va-card {
      margin-bottom: 0 !important;
    }
  }
</style>
